<template>
  <div>
    <div class="row">
      <div class="col-12 articles">
        <ArticleSmall :key="newsItem.id" v-for="newsItem in includedNewsItems" :news-item="newsItem"></ArticleSmall>
      </div>
    </div>
    <div class="pagination-wrapper">
      <Pagination :item-count="totalNewsItems" :items-per-page="newsItemsPerPage"></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/UI/Pagination";
import ArticleSmall from "./ArticleSmall";

export default {
  name: "ArticleList",
  components: { Pagination, ArticleSmall },
  props: {
    title: String,
    newsItems: Array,
    exclude: Array,
    totalNewsItems: Number,
    newsItemsPerPage: Number
  },
  data()
  {
    return {
      articles: [],
      page: 1
    }
  },
  computed: {
    includedNewsItems()
    {
      if (this.exclude && this.exclude.length > 0)
      {
        return this.newsItems.filter(newsItem => !this.exclude.includes(newsItem.id));
      }

      return this.newsItems;
    }
  }
}
</script>

<style lang="scss" scoped>
.articles
{
  display: flex;
  flex-direction: column;
}

.header
{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;

  .title
  {
    font-size: 1.3rem;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }
}

.btn-toolbar
{
  gap: 1rem;

  .btn-search, .btn-filter
  {
    background-color: $primary-blue;
    color: $font-light;
  }
}

.pagination-wrapper
{
  overflow-x: auto;

  &::v-deep .pagination
  {
    justify-content: flex-start !important;
  }
}
</style>